import { MAGIC_SEARCH_URL } from 'config/constants';
import { ScopedURLBuilder } from 'utils/linkUtils';

const builder = new ScopedURLBuilder(MAGIC_SEARCH_URL);

export const magic = {
  getSearch: builder.createAPICall('search?q=:searchItem&action=Search'),
};
